import { render, staticRenderFns } from "./DisagreeSpouseSupport.vue?vue&type=template&id=38c88e6f"
import script from "./DisagreeSpouseSupport.vue?vue&type=script&lang=ts"
export * from "./DisagreeSpouseSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports